module.exports = __webpack_public_path__ + "static/006-da64234ef454c504a5e835bdfd9d2aa3.png";